import CategoryItem from 'components/Category';
import Spin from 'components/Spin';
import Text from 'components/Text';
import cashierActions from 'features/cashier/services/actions';
import cashierSelectors from 'features/cashier/services/selectors';
import { ICategory } from 'features/cashier/services/types/api';
import React, { useCallback } from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';

const Category = () => {
  const loading = cashierSelectors.loading.getCategories();
  const dispatch = useAppDispatch();
  const categories = cashierSelectors.getCategories();
  const categoryActive = cashierSelectors.getActiveCategory();
  const serviceIdsSelected = cashierSelectors.getServiceIdsSelected();

  const handleClickCategory = (item: ICategory) => {
    dispatch(cashierActions.selectCategory(item));
  };

  const renderItem = useCallback((item: ICategory) => {
    return (
      <CategoryItem
        onClick={() => handleClickCategory(item)}
        selected={item.services.some(o => !!serviceIdsSelected.find(s => s.id === o.id))}
        isActive={categoryActive?.id === item.id}
      >
        <Text variant='CONTENT_2' color='text_3' textTransform='uppercase'>{item.categoryName}</Text>
      </CategoryItem>
    );
  }, [categories, categoryActive, serviceIdsSelected]);

  return (
    <ScrollDivStyled>
      <Text variant="H6" mt={1} color="text_2" px={1.5} pb={0.5}>
        CATEGORIES
      </Text>
      <div className="scroll-div">
        <div className="children-scroll">
          <CategoriesListStyled>{categories.map(renderItem)}</CategoriesListStyled>
        </div>
      </div>
      {loading && <Spin />}
    </ScrollDivStyled>
  );
};

export default Category;
export const ScrollDivStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  .scroll-div {
    flex: 1;
    position: relative;
  }
  .children-scroll {
    position: absolute;
    inset: 0;
    overflow: auto;
    padding: 1rem 1.5rem;
    &::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background-color: #F5F5F5;
    }
  
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,0.5);
      &:hover {
        background-color: rgba(0,0,0,0.6);
      }
    }
  
    &::-webkit-scrollbar-track {
      border-radius: 4px;
      background-color: #F5F5F5;
    }
  }
`;

export const CategoriesListStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 16px;
  
`;